// Import utilities
const {
	isDefined
} = _uo.utility;

/**
 * Checks whether the user has Pro or not
 *
 * @return {Boolean} True if it has Automator Pro
 */
const isAutomatorProActive = () => {
	return isDefined( UncannyAutomator.wp ) && UncannyAutomator.wp;
}

export default isAutomatorProActive;
